import classNames from "classnames";
import React, { PropsWithChildren, ReactElement } from "react";
import ReactDOM from "react-dom";
import { CSSTransition } from "react-transition-group";
import { withDefault } from "../../utils/withDefault";
import { AppDimmer } from "./AppDimmer";
import { If } from "./If";

export interface AppBottomSheetProps {
  isOpen: boolean;
  title?: string;
  density?: "default" | "densed";
  rounded?: boolean;
  className?: string;
  color?: "default" | "warning";
  restrictHeight?: boolean;
  onRequestClose: () => void;
}

export function AppBottomSheet(props: PropsWithChildren<AppBottomSheetProps>): ReactElement {
  const parent = document.getElementById("modal-root") ?? document.body;

  return ReactDOM.createPortal(
    <CSSTransition in={props.isOpen} timeout={500} classNames="AppBottomSheet" unmountOnExit={true}>
      <div
        data-density={withDefault(props.density, "default")}
        data-color={withDefault(props.color, "default")}
        className={classNames("AppBottomSheet", props.className, {
          RoundBorders: props.rounded === true,
        })}
      >
        <div
          className="AppBottomSheet_Container"
          data-restrict-height={props.restrictHeight !== false}
        >
          <If condition={props.title !== undefined} comment="if popover has title">
            <div className="AppBottomSheet_Header">
              <h2 className="AppBottomSheet_Title">{props.title}</h2>
            </div>
          </If>
          <div className="AppBottomSheet_Content">{props.children}</div>
        </div>
        <AppDimmer onClick={props.onRequestClose} />
      </div>
    </CSSTransition>,
    parent
  );
}
